import React, {Fragment, useEffect, useContext} from 'react';
import {BrowserRouter as Router, Switch, Route, Redirect} from 'react-router-dom';
import ProtectedRoute from "./components/ProtectedRoute";
import ReactGA from 'react-ga';

/*
* @ Component Imported
* */
import Home from "./pages/home/Home";
// import HomePublic from "./pages/home/HomePublic";
import ProductsTwoColumnLeftSidebarPage from "./pages/products/TwoColumnLeftSidebar";
import ProductDetailsSidebarPage from "./pages/products/ProductDetailsSidebar";
import AboutPage from "./pages/about";
import ErrorPage from "./pages/404Error";
import AccountSettings from "./pages/account";
import PrivacyPolicy from "./pages/terms";
import {GlobalContext} from "./handlers/GlobalContext";
import CookieConsent from "react-cookie-consent";

const TRACKING_ID = "UA-226385653-1";
ReactGA.initialize(TRACKING_ID);

const App = () => {
    const [ state, dispatch] = useContext(GlobalContext);

    // Set Default Color On Body
    const body = document.querySelector('body');
    body.classList.add('color-var-4');

    useEffect(() => {
        if( !!state.authenticated && !state.authError ) return;
        dispatch({ type: 'SET_UNAUTHORIZED' });
    }, [ state.authenticated ]);


    useEffect(() => {
        ReactGA.pageview(window.location.pathname + window.location.search);
    }, []);

    // Reload when locale has changed!
    useEffect(() => {
        if(!state.locale.localeChanged) return;
        window.location.reload(false);
    }, [ state.locale.localeChanged ]);

    const logout = () => { dispatch({ type: 'SET_UNAUTHORIZED' }) };

    const translate = (term, alt) => {
        return state.locale.translation[term] || alt || term;
    }

    return (
        <Fragment>
            {/*<Switcher/>*/}
            <Router>
                <Switch>

                    <ProtectedRoute path={`${process.env.PUBLIC_URL + "/medicinal-products/:id"}`}
                           component={ProductDetailsSidebarPage}/>
                    <ProtectedRoute path={`${process.env.PUBLIC_URL + "/medicinal-products"}`}
                           component={ProductsTwoColumnLeftSidebarPage}/>
                    <Route path={`${process.env.PUBLIC_URL + "/about"}`}
                           component={AboutPage}/>
                    <ProtectedRoute path={`${process.env.PUBLIC_URL + "/user-profile"}`}
                           component={AccountSettings}/>
                    {/*<Route path={`${process.env.PUBLIC_URL + "/logout"}`}*/}
                           {/*component={HomePublic}/>*/}
                    <Route exact path={`${process.env.PUBLIC_URL + "/logout"}`} render={() => {
                        logout();
                        return <Redirect to={`${process.env.PUBLIC_URL + "/"}`} />;
                    }} />
                    <Route exact path={`${process.env.PUBLIC_URL + "/"}`}
                           component={Home}
                    />
                    {/*<Route path={`${process.env.PUBLIC_URL + "/privacy-policy"}`}*/}
                           {/*component={PrivacyPolicy}/>*/}
                    <Route exact component={ErrorPage}/>
                </Switch>
            </Router>
            <CookieConsent
                buttonText={translate("cookie-consent-button","Understand & Accept")}
                buttonStyle={{ background: "#0a69cc", color: "#eeeeee", fontSize: "14px" }}>
                {translate("cookie-consent-message","This website uses cookies to enable the functionality and enhance the user experience.")}
            </CookieConsent>
        </Fragment>
    );
};

export default App;